const setRequiredFields = (state, payload) => {
  state.requiredFields = payload
}

export default {
  setRequiredFields
}
